// Public routes (accessible by anyone)
export const LANDING = "/";
export const CUSTOMER_ORDER = "/pedido";
export const ORDER_TRACKING = "/order-tracking/:organizationId/:orderId";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const SIGN_IN_PT = "/entrar";
export const SIGN_IN_ARG = "/signin/:email/:password";
export const SIGN_IN_ARG_PT = "/entrar/:email/:password";
export const PASSWORD_FORGET = "/pw-forget";

// Admin routes (require authentication)
export const ADMIN = "/admin";
export const HOME = "/admin/checkout";
export const ACCOUNT = "/admin/account";
export const ACCOUNT_PT = "/admin/conta";
export const ADMIN_ORGANIZATIONS = "/admin/organizations";
export const ADMIN_DELIVERY_AREAS = "/admin/delivery-areas";
export const ADMIN_PRODUCTS = "/admin/products";
export const ADMIN_PRODUCTS_ADD = "/admin/products/add";
export const ADMIN_PRODUCTS_EDIT = "/admin/products/:id";
